import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import { connect } from 'react-redux';
// import Dropdown from 'components_v2/common/Dropdown';
import SubsectionList from 'components_v2/mobile/SubsectionList';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import makeRequest from 'utils/makeRequest';
// import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen';
import s from './TileLayout.scss';
import Card from '../../../../../components_v2/common/CardV2';
import Morebtn from '../../../../../components_v2/mobile/Morebtn';
import Listingheader from '../../../components/common/ListingheaderV2';
import SponserAdSlot from '../../common/SponserAdSlot';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class TileLayout extends React.Component {
  constructor() {
    super();
    this.state = {
      items: [],
    };
  }

  componentDidMount() {
    const { sectionData, lazyload } = this.props;
    if (
      sectionData &&
      !lazyload &&
      !Array.isArray(sectionData) &&
      sectionData.dataUrl
    ) {
      this.loadLayoutData(sectionData.dataUrl);
    }
  }

  loadSection = () => {
    const { sectionData } = this.props;
    if (sectionData && !Array.isArray(sectionData) && sectionData.dataUrl) {
      this.loadLayoutData(sectionData.dataUrl);
    }
  };

  loadLayoutData = (dataUrl, ajaxCall, moreText, morePath) => {
    if (!dataUrl) {
      return;
    }

    this.setState({ loading: true });

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          ((data.data.items && data.data.items.length > 0) ||
            data.data.length > 0)
        ) {
          //console.log('data : ', data.data);
          this.setState({
            items: data.data.items || data.data,
            ajaxCall: !!ajaxCall,
            loading: false,
            moreText,
            morePath,
          });
        } else {
          this.setState({ loading: false });
        }
      });
  };

  toggleLoader = loading => {
    this.setState({ loading });
  };

  getCardItemWithPrimeIcon = item => {
    if (typeof item === 'object') {
      item.cs = item.primeid === '100' ? 'prime' : item.cs;
    }
    return item;
  };

  renderComponent = () => {
    const {
      sectionData = {},
      moreLink,
      hideMoreBtn = false,
      moreTextVal,
      className,
      useIdForGA,
    } = this.props;

    // const listItems = sectionData.items;
    // const listItems = sectionData.items || this.state.items;
    let listItems = [];

    if (this.state.ajaxCall) {
      listItems = this.state.items;
    } else {
      listItems = sectionData.items || sectionData.data || this.state.items;
    }
    // let fifaButtonText;
    if (this.props?.isFifaWidget) {
      listItems = sectionData;
    }
    // const primeBtn = _get(sectionData, 'primebtn') || undefined;
    const moreText = _get(sectionData, 'name') || 'more';
    const tn = _get(sectionData, 'tn') || '';

    const gaAction = useIdForGA
      ? `click-${sectionData[useIdForGA ? 'id' : 'name']
          .replace(/ /g, '')
          .toLowerCase()}`
      : '';
    let tileItems = [];
    if (Array.isArray(listItems) && listItems.length > 0) {
      tileItems = listItems.slice(1);
    }
    // if (this.props?.isFifaWidget) {
    //   fifaButtonText = 'MORE FIFA VIDEOS';
    // }

    return (
      <React.Fragment>
        <div
          className={`${s.tileLayout} ${this.state.loading ? s.loader : ''}`}
        >
          {!this.props?.isFifaWidget && (
            <>
              {this.props.listingHeader ? (
                <SubsectionList
                  data={sectionData.subSections}
                  dropdownTitle={sectionData.dropdownTitle}
                  onChangeCallback={this.loadLayoutData}
                  sectionId={sectionData.id}
                  showSearchBox
                  gaData={{
                    gaAction: `${sectionData.name}-TabChange`,
                    partialGaLabel: 'Click',
                  }}
                  toggleLoader={this.toggleLoader}
                  headingname={sectionData.name}
                  headingLink={sectionData.link || sectionData.path}
                  linkData={{
                    gaAction,
                    gaLabel: `${sectionData.link || sectionData.path}`,
                  }}
                  usePopupPortal={this.props.usePopupPortal}
                  isMobile={this.props.isMobile}
                  ga4Category={sectionData?.ga4Category}
                  ga4Type={sectionData?.ga4Type}
                />
              ) : (
                <>
                  <Listingheader
                    doNotChangeURL={sectionData.dnc === '1'}
                    headingname={
                      sectionData.id === 'toiplus' ||
                      sectionData.id === 'toi_plus' ? (
                        <>
                          <i />Stories
                        </>
                      ) : (
                        sectionData.name
                      )
                    }
                    headingLink={sectionData.link || sectionData.path}
                    overrideClass={`${className} ${
                      sectionData.id === 'toiplus' ||
                      sectionData.id === 'toi_plus'
                        ? s.toiPlusHeading
                        : ''
                    }`}
                    linkData={{
                      gaAction,
                      gaLabel: 'Click-Header',
                    }}
                    loading={this.state.loading}
                    data={sectionData}
                    isPrime={this.props.isPrime}
                    isWapView
                    ga4Category={sectionData?.ga4Category}
                    ga4Type={sectionData?.ga4Type}
                  />
                  <SponserAdSlot
                    data={sectionData}
                    isPrime={this.props.isPrime}
                    isWapView
                  />
                </>
              )}
            </>
          )}

          {listItems &&
            listItems instanceof Array &&
            listItems.length > 0 && (
              <Card
                data={this.getCardItemWithPrimeIcon(listItems[0])}
                ga4Category={sectionData?.ga4Category}
                ga4Type={sectionData?.ga4Type}
                gaIndex="1"
                isLeadImageNews
                key="card_0"
                doNotChangeURL={
                  listItems[0].dnc === '1' || sectionData.dnc === '1'
                }
                target={listItems.target === '1' || sectionData.target === '1'}
                linkData={{
                  gaAction: `${
                    tn === 'ipl_tile_pgwdt'
                      ? `Click0_${sectionData.name}`
                      : `${gaAction}-0`
                  }`,
                  gaLabel: `${listItems[0].wu}`,
                  noSpaceReplace: tn === 'ipl_tile_pgwdt',
                }}
              />
            )}

          <div className={s.col2}>
            {tileItems instanceof Array &&
              tileItems.map((item, itemIndex) => (
                <Card
                  data={this.getCardItemWithPrimeIcon(item)}
                  ga4Category={sectionData?.ga4Category}
                  ga4Type={sectionData?.ga4Type}
                  gaIndex={itemIndex + 1}
                  // isInlineSmallIconCard
                  //isMobileInlineVideo
                  isVerticalTile
                  plusIconNotRequired={item.cs === 'prime'}
                  key={`card_${item.wu || itemIndex}`}
                  linkData={{
                    gaAction: `${
                      tn === 'ipl_tile_pgwdt'
                        ? `Click${itemIndex + 1}_${sectionData.name}`
                        : `${gaAction}-${itemIndex + 1}`
                    }`,
                    gaLabel: `${item.wu}`,
                    noSpaceReplace: tn === 'ipl_tile_pgwdt',
                  }}
                  isHalfMobileTile
                  doNotChangeURL={item.dnc === '1' || sectionData.dnc === '1'}
                  target={
                    tileItems.target === '1' || sectionData.target === '1'
                  }
                />
              ))}
          </div>

          {!hideMoreBtn && (
            <Morebtn
              moreText={moreText}
              absoluteMoreText={
                moreTextVal || this.state.moreText || sectionData.moreText
              }
              moreLink={this.state.morePath || moreLink}
              doNotChangeURL={sectionData.dnc === '1'}
              target={sectionData.target === '1'}
              linkData={{
                gaAction,
                gaLabel: 'Click-MoreStories',
              }}
              ga4Category={sectionData?.ga4Category}
              ga4Type={sectionData?.ga4Type}
            />
          )}
          {/* {primeBtn && (
            <PrimeScreen componentName="HPPrimeInlineWidget" isWapView />
          )} */}
        </div>
      </React.Fragment>
    );
  };
  // Ga4 widget view call
  ga4ViewElement = sectionData => {
    if (sectionData?.ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `${sectionData.ga4Type}`,
        category: `${sectionData?.ga4Category ? sectionData?.ga4Category : ''}`,
      });
    }
  };
  render() {
    const { lazyload = false, sectionData } = this.props;
    return (
      <>
        {lazyload ? (
          <InViewObserver
            inViewCallback={() => {
              this.loadSection();
              this.ga4ViewElement(sectionData);
            }}
            viewMargin="300px 0px 300px 0px"
          >
            {this.renderComponent()}
          </InViewObserver>
        ) : (
          <InViewObserver
            inViewCallback={() => {
              this.ga4ViewElement(sectionData);
            }}
          >
            {this.renderComponent()}
          </InViewObserver>
        )}
      </>
    );
  }
}
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});
TileLayout.propTypes = {
  sectionData: PropTypes.shape({
    inserts: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  // loadAjaxSectionData: PropTypes.func,
  typeComponentMapping: PropTypes.shape({}),
  moreLink: PropTypes.string.isRequired,
  hideMoreBtn: PropTypes.bool,
  listingHeader: PropTypes.bool,
  usePopupPortal: PropTypes.bool,
  className: PropTypes.string,
  lazyload: PropTypes.bool,
  useIdForGA: PropTypes.bool,
  isFifaWidget: PropTypes.bool,
  isMobile: PropTypes.bool,
};
TileLayout.defaultProps = {
  // loadAjaxSectionData: undefined,
  typeComponentMapping: undefined,
  hideMoreBtn: false,
  listingHeader: false,
  usePopupPortal: false,
  className: '',
  lazyload: false,
  useIdForGA: false,
  isFifaWidget: false,
  isMobile: false,
};

export default connect(mapStateToProps)(TileLayout);
